<template>
  <div>
    system.advice
  </div>
</template>
<script>
import * as annoService from '../../../services/announcement'
export default {
  name: 'zk-system-announcement',
  data () {
    let _self = this
    let data = []
    let params = {}
    let columns = [
      {
        prop: 'id',
        label: this.$t('announcement.id')
      }, {
        prop: 'content',
        label: this.$t('announcement.content')
      }, {
        prop: 'validDate',
        label: this.$t('announcement.validDate')
      }, {
        prop: 'modifiedDate',
        label: this.$t('announcement.modifiedDate')
      }, {
        prop: 'modifiedBy',
        label: this.$t('announcement.modifiedBy')
      }, {
        prop: 'createdDate',
        label: this.$t('announcement.createdDate')
      }, {
        prop: 'createdBy',
        label: this.$t('announcement.createdBy')
      }, {
        label: this.$t('common.operation'),
        rendar: (h, params) => {
          return h('zk-operate-bar', {
            props: {
              showText: false
            },
            on: {
              update () {
                _self.row = params.row
                _self.update()
              },
              remove () {
                _self.row = params.row
                _self.remove()
              }
            }
          })
        }
      }]
    let row = {}
    return {
      params,
      columns,
      data,
      row
    }
  },
  mounted () {
    this.list()
  },
  methods: {
    list () {
      this.pager.curPage = 1 // 当前页面
      this.commList()
    },
    commList () {
      annoService.list({
        pager: this.pager,
        params: this.params
      }).then(data => {
        this.data = data.payload.results
        console.log(this.data)
      })
    }
  }
}
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/systemAnnouncement/src/main.vue